import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';
import classnames from 'classnames';

import { QUERY_UNION_BOOKING_DETAIL } from '../queries';
import Header from './components/header';
import StudentInfo from './components/student-info';
import ProductInfo from './components/product-info';
import CommissionInfo from './components/commission-info';

export const tabList = ['STUDENT_INFO', 'PRODUCT_INFO', 'COMMISSION_INFO'];

export default function ManualDetail() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [bookingInfo, setBookingInfo] = useState({});
  const [isFixed, setIsFixed] = useState(false);
  const [activeTab, setActiveTab] = useState(tabList[0]);
  const referenceId = pathname.split('/')[2];

  const handleScrollHref = () => {
    const scrollTop = document.documentElement.scrollTop;
    setIsFixed(scrollTop > 250);
  };

  const handleSelectTab = tab => {
    setActiveTab(tab);
  };

  const { loading } = useQuery(QUERY_UNION_BOOKING_DETAIL, {
    fetchPolicy: 'no-cache',
    variables: {
      referenceId,
    },
    onCompleted: data => {
      if (data.getUnionBooking?.opportunity) {
        setBookingInfo(data.getUnionBooking.opportunity);
      }
    },
  });

  useEffect(() => {
    window.addEventListener('scroll', handleScrollHref);
    return () => {
      window.removeEventListener('scroll', handleScrollHref);
    };
  }, []);

  if (loading) {
    return (
      <div
        style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Spin />
      </div>
    );
  }

  return (
    <div className="manual-detail-wrapper">
      <Header orderInfo={bookingInfo} />
      <div className={classnames('tab-wrapper', isFixed && 'fixed-container')}>
        <For of={tabList} each="item" index="index">
          <a
            onClick={() => handleSelectTab(item)}
            href={`#${item?.toLowerCase()}`}
            className={classnames('tab-link', { 'active-link': activeTab === item })}
          >
            {t(`cms.reconciliation.lead_generation.detail.${item?.toLowerCase()}.tab`)}
          </a>
        </For>
      </div>
      <div className="info-wrapper">
        <div id="student_info" style={{ marginBottom: 0 }}>
          <StudentInfo student={bookingInfo.student} orderInfo={bookingInfo} />
        </div>
        <div id="product_info">
          <ProductInfo t={t} productInfo={bookingInfo} />
        </div>
        <div id="commission_info">
          <CommissionInfo t={t} commissionInfo={bookingInfo} />
        </div>
      </div>
    </div>
  );
}
